import styled from "styled-components";

interface IStatusDiv {
  status?: string;
}
export const StatusDiv = styled.div<IStatusDiv>`
  ${(props) => {
    const status = props.status;
    let color, backgroundColor;
    if (status === "received") {
      color = props.theme.colors.blackTextBody;
      backgroundColor = "rgba(48, 52, 92, 0.1)";
    } else if (status === "problem") {
      color = props.theme.colors.supportRed;
      backgroundColor =
        props.theme.colors.supportRed + props.theme.transparencies.p10;
    } else if (status === "warning") {
      color = props.theme.colors.blackTextBody;
      backgroundColor = props.theme.colors.supportYellow;
    } else if (status === "ok") {
      color = props.theme.colors.betterGreen;
      backgroundColor =
        props.theme.colors.betterGreen + props.theme.transparencies.p10;
    } else {
      color = props.theme.colors.gray;
      backgroundColor =
        props.theme.colors.gray72 + props.theme.transparencies.p20;
    }
    return `
      background-color: ${backgroundColor};
      box-sizing: border-box;
      height: 2.5rem;
      margin-bottom: 0.5rem;
      margin-top: 0.5rem;
      p {
        box-sizing: border-box;
        color: ${color};
        font-size: 1.1rem;
        font-weight: 600;
        margin: 0rem;
        padding: 0.5rem;
        text-align: center;
        width: auto;
      }
    `;
  }}
`;
